import type { Player } from "@/game/types/Game";
import { twMerge } from "tailwind-merge";
import crown from "src/assets/img/crown.svg";
import { useState } from "react";

const Polaroid = ({
    className,
    imagePath,
    player,
    style,
}: {
    imagePath: string;
    className?: string;
    style?: React.CSSProperties;
    player?: Player;
}) =>
{
    const blurPhotos = localStorage.getItem("blur_photos") === "1";

    const [blur, setBlur] = useState(blurPhotos);

    return (
        <div
            className={twMerge(
                Wind.style({
                    position: "relative",
                    display: "flex",
                    flexDirection: "flex-col",
                    justifyContent: "justify-center",
                    alignItems: "items-center",
                    backgroundColor: "bg-white",
                    paddingTop: "pt-4",
                    paddingX: "px-4",
                    maxWidth: "max-w-[24.375rem]",
                    marginTop: "mt-12",
                }).class,
                !player && "pb-14",
                className
            )}
            style={style}
        >
            {player && (
                <img
                    src={crown}
                    className={
                        Wind.style({
                            position: "absolute",
                            width: "w-[7.266rem]",
                            top: "-top-10",
                            right: "-right-10",
                            transformTranslate: "translate-[-50%,-50%]", // Adjust this if necessary
                            zIndex: "z-[10000]",
                        }).class
                    }
                />
            )}
            <div
                className={
                    Wind.style({
                        width: "w-full",
                        height: "h-full",
                        position: "relative",
                        overflow: "overflow-hidden",
                        cursor: "cursor-pointer",
                    }).class
                }
                onClick={() =>
                {
                    setBlur(!blur);
                }}
            >
                <div
                    className={
                        Wind.style({
                            position: "absolute",
                            top: "top-0",
                            left: "left-0",
                            width: "w-full",
                            height: "h-full",
                            backgroundColor: "bg-black",
                            zIndex: "z-0",
                        }).class
                    }
                />
                <img
                    src={imagePath}
                    className={
                        Wind.style({
                            width: "w-full",
                            height: "h-full",
                            objectFit: "object-cover",
                            filterBlur:
                                blur && blurPhotos ? "blur" : "blur-none",
                            position: "relative",
                            transition: "transition-all ease-in-out",
                            transitionDuration: "duration-300",
                        }).class
                    }
                />
            </div>
            {player && (
                <div
                    className={
                        Wind.style({
                            display: "flex",
                            gap: "gap-2",
                            alignItems: "items-center",
                            paddingY: "py-2",
                        }).class
                    }
                >
                    <img
                        src={player.avatar.path}
                        alt={`Avatar of ${player.name}`}
                        className={
                            Wind.style({
                                width: "w-11",
                                height: "h-11",
                                borderRadius: "rounded-full",
                            }).class
                        }
                    />
                    <span
                        className={
                            Wind.style({
                                color: "text-[#031E3E]",
                                fontFamily: "font-cursive",
                                fontWeight: "font-normal",
                                fontSize: "text-2xl",
                                lineHeight: "leading-[83%]",
                                textAlign: "text-center",
                            }).class
                        }
                    >
                        {player.name}
                    </span>
                </div>
            )}
        </div>
    );
};

export default Polaroid;
